import React from "react";
import moment from "moment";
import {
  TextField,
  Grid,
  Chip,
  IconButton,
  Checkbox,
  Tooltip,
  FormControlLabel
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ReactChipInput from "../components/common/ChipInput/ReactChipInput";
import _ from "lodash";
import {
  removeDuplicates,
  getDistinctByProperty,
  numberWithCommas
} from "./helper";
import { Switch } from "../components/common/Switch";
import InputMask from "react-input-mask";
import { Add, Remove } from "@material-ui/icons";
import Clear from "@material-ui/icons/Clear";

export function getColumnControl(row, column, handleTableHeaderEditChange) {
  const value = (row || {})[column.key];
  const editConfig = column.editConfig;
  switch ((editConfig.type || "").trim()) {
    case "Checkbox":
      return (
        <>
          <Tooltip title={!value ? editConfig.toolTip1 : editConfig.toolTip2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={e =>
                    handleTableHeaderEditChange(e.target.checked, column.key)}
                  name={editConfig.name}
                  color={"default"}
                  size={"small"}
                  className={"white-checkbox"}
                />
              }
            />
          </Tooltip>
        </>
      );
    default:
      return false;
  }
}
function getFormattedData(
  row,
  column,
  isInAddMode,
  EditSource,
  selectedEditRowId,
  handleTableValueChange,
  showLabel = false,
  props,
  index = 0,
  viewTagData,
  showCollapsible,
  handelCollapsible,
  selected
) {
  // function disableDatesForPayCycleStart(date) {
  //   if (column.isPayCycle) {
  //     if (date.getDate() === 1 || date.getDate() === 16) {
  //       return false;
  //     }
  //     return true;
  //   }
  //   return false;
  // }

  let value = (row || {})[column.key];
  if (
    (column.editConfig !== undefined && column.editConfig.multiple) ||
    _.camelCase(column.dataFormat) === _.camelCase("MultiText")
  ) {
    value = value ? (value || "").split(column.editConfig.delimiter) : [];
  }

  let label = <></>;
  if (showLabel === true) {
    label = <div> {column.name} </div>;
  }
  const notEditTypeValue = (column.notEditWhen || {}).value;
  const notEditTypeKey = (column.notEditWhen || {}).key;
  if (
    (selectedEditRowId !== undefined &&
      // column.isEditable === true &&
      column.editConfig !== undefined &&
      row[selectedEditRowId.key] === selectedEditRowId.value &&
      column.editConfig.isEditField === true &&
      isInAddMode === false &&
      (column.notEditWhen === undefined ||
        notEditTypeValue !== row[notEditTypeKey])) ||
    (selectedEditRowId !== undefined &&
      // column.isEditable === true &&
      column.editConfig !== undefined &&
      row[selectedEditRowId.key] === selectedEditRowId.value &&
      column.editConfig.isAddField === true &&
      isInAddMode === true &&
      (column.notEditWhen === undefined ||
        notEditTypeValue !== row[notEditTypeKey]))
  ) {
    const dataSource = _.cloneDeep(
      EditSource.find(x => x.key === column.editConfig?.sourceKey)
    );
    if (column.filterSourceOn) {
      let dropdownSource = [];
      column.filterSourceOn.forEach(ele => {
        const idValue = row[ele.key];
        if (idValue) {
          dropdownSource = dataSource.data.filter(
            x =>
              (x[ele.filterBy] || "").toString() ===
                (idValue || "").toString() ||
              (ele.ignoreWhen &&
                x[ele.ignoreWhen.key]?.toString() ===
                  ele.ignoreWhen.value?.toString())
          );
          dataSource.data = dropdownSource.filter(
            (ele, ind) =>
              ind ===
              dropdownSource.findIndex(
                elem => elem[column.fieldId] === ele[column.fieldId]
              )
          );
        }
      });
    }
    if (column.editConfig?.distinctOn) {
      dataSource.data = getDistinctByProperty(
        dataSource.data,
        column.editConfig?.distinctOn
      );
    }
    const isInErrorState = column.isInErrorState;
    const errorMessage = column.errorMessage;
    const isEditable =
      selectedEditRowId.mode === "View" ? true : column.disabled;
    const isAvoidFormatting = column.editConfig?.isAvoidFormatting ?? false;
    if (showLabel === true) {
      label = (
        <div>
          {" "}
          {
            <>
              <span>{column.name}</span>{" "}
              {!isEditable && column.isRequired ? (
                <span className={"error-text"}>{"*"}</span>
              ) : (
                ""
              )}
            </>
          }{" "}
        </div>
      );
    }
    if (!isEditable) {
      switch ((column.editConfig.type || "").trim()) {
        case "DropDown":
          return (
            <>
              <b>{label}</b>
              <Autocomplete
                size={"small"}
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                multiple={column.editConfig.multiple || false}
                limitTags={2}
                options={(dataSource.data || []).map(
                  option => option[column.editConfig.sourceOption]
                )}
                value={
                  column.editConfig.multiple === true ? value || [] : value
                }
                className={"editable"}
                key={"dropDown_filter" + column.editConfig.title}
                id={"dropDown_filter" + column.editConfig.title}
                onChange={(event, value) => {
                  handleTableValueChange(
                    getFormattedValues(value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  );
                }}
                autoHighlight
                renderInput={params => (
                  <TextField
                    disabled={isEditable}
                    error={isInErrorState}
                    helperText={errorMessage}
                    {...params}
                    margin={"normal"}
                    className={"table-text"}
                    placeholder={
                      value && value.length
                        ? ""
                        : `Please select ${column.name}.`
                    }
                  />
                )}
              />
            </>
          );
        case "TextField":
          return (
            <>
              <b>{label}</b>
              <TextField
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                margin={"normal"}
                size={"small"}
                color={"primary"}
                className={"editable"}
                value={
                  isAvoidFormatting
                    ? isNaN(value)
                      ? 0
                      : (value?.toString() || "").slice(-1) === "."
                      ? value
                      : Math.round(Math.abs(value) * 100) / 100
                    : getFormattedValues(value, column.dataFormat, true)
                }
                onChange={e =>
                  handleTableValueChange(
                    isAvoidFormatting
                      ? isNaN(e.target.value)
                        ? 0
                        : e.target.value?.toString() || "" === "."
                        ? e.target.value
                        : Math.round(Math.abs(e.target.value) * 100) / 100
                      : getFormattedValues(
                          e.target.value,
                          column.dataFormat,
                          true
                        ),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )}
                  fullWidth
              />
            </>
          );
        case "PhoneNumber":
          return (
            <>
              <b>{label}</b>

              <InputMask
                mask={"999-999-9999"}
                value={getFormattedValues(value, column.dataFormat, true)}
                disabled={isEditable}
                maskChar={" "}
                onChange={e =>
                  handleTableValueChange(
                    getFormattedValues(e.target.value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )}
              >
                {() => (
                  <TextField
                    error={isInErrorState}
                    helperText={errorMessage}
                    margin={"normal"}
                    size={"small"}
                    color={"primary"}
                    className={"editable"}
                  />
                )}
              </InputMask>
            </>
          );

        case "DatePicker":
          return (
            <>
              <b>{label}</b>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                key={"datePicker_filter" + column.key + index}
              >
                <Grid container>
                  <KeyboardDatePicker
                    disabled={isEditable}
                    error={isInErrorState}
                    clearable
                    helperText={errorMessage}
                    minDate={column.minDate}
                    maxDate={column.maxDate}
                    className={"editable"}
                    size={"small"}
                    margin={"normal"}
                    key={"datePickerFilter" + column.key + index}
                    id={"date-picker-dialog"}
                    // shouldDisableDate={(date) => { disableDatesForPayCycleStart(date, column.isPayCycle); }}
                    // inputValue={value  || null}
                    shouldDisableDate={column.editConfig.shouldDisableDate}
                    value={value || null}
                    onChange={date => {
                      // if (
                      //   date !== '' &&
                      //   moment(date).format('MM/DD/YYYY') !== 'Invalid date'
                      // ) {if(dat)
                      handleTableValueChange(
                        getFormattedValues(date, column.dataFormat, true),
                        column.key,
                        row,
                        isInAddMode,
                        index
                      );
                      // }
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          onClick={() => {
                            document.getElementById(
                              "date-picker-dialog"
                            ).value = "";

                            handleTableValueChange(
                              null,
                              column.key,
                              row,
                              isInAddMode,
                              index
                            );
                          }}
                        >
                          <Clear />
                        </IconButton>
                      )
                    }}
                    format={"MM/dd/yyyy"}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </>
          );
        case "ChipInput":
          return (
            <>
              <ReactChipInput
                required={column.isRequired}
                className={"custom-chipInput"}
                value={value}
                onChange={value => {
                  handleTableValueChange(
                    getFormattedValues(value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  );
                }}
              />
            </>
          );
        case "Switch":
          return (
            <>
              <Switch
                disabled={isEditable}
                isChecked={value}
                onChangeValues={e =>
                  handleTableValueChange(
                    getFormattedValues(e, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )}
                id={`label-${column.key}`}
                key={column.key}
                fieldkey={column.key}
                obj={column}
                labelText={column.name}
                fullWidth
                row={row}
                column={column}
                isInAddMode={isInAddMode}
                toolTip={column.editConfig.toolTip}
              />
            </>
          );
        case "CheckBox":
          return (
            <>
              <Checkbox
                checked={value}
                disabled={isEditable}
                onChange={e =>
                  handleTableValueChange(
                    e.target.checked,
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )}
                fieldkey={column.key}
                obj={column}
                labelText={column.name}
                fullWidth
                row={row}
                column={column}
                isInAddMode={isInAddMode}
              />
            </>
          );
        case "TextNumber":
            return (
              <>
                <b>{label}</b>
                <TextField
                  disabled={isEditable}
                  error={isInErrorState}
                  helperText={errorMessage}
                  fullWidth
                  margin={"normal"}
                  size={"small"}
                  color={"primary"}
                  className={"editable"}
                  type={"number"}
                  value={value}
                  onChange={(e) =>
                    handleTableValueChange(
                      e.target.value,
                      column.key,
                      row,
                      isInAddMode,
                      index
                    )}
                />
              </>
            );
         
          default:
          return false;
      }
    } else {
      return formattedComponent(
        column,
        row,
        value,
        props,
        viewTagData,
        showCollapsible,
        selected,
        handelCollapsible,
        index,
        label,
        selectedEditRowId
      );
    }
  } else {
    return formattedComponent(
      column,
      row,
      value,
      props,
      viewTagData,
      showCollapsible,
      selected,
      handelCollapsible,
      index,
      label,
      selectedEditRowId
    );
  }
}
function formattedComponent(
  column,
  row,
  value,
  props,
  viewTagData,
  showCollapsible,
  selected,
  handelCollapsible,
  index,
  label,
  selectedEditRowId
) {
  if (column.concatFields) {
    column.concatFields.forEach(field => {
      const concatValue = row[field] || "";
      if (concatValue.length > 0) {
        value = value + " " + concatValue;
      }
    });
  }
  const component = getFormattedValues(
    value,
    column.dataFormat,
    false,
    column,
    props,
    viewTagData,
    "",
    selectedEditRowId !== undefined && selectedEditRowId.value !== undefined,
    props?.config?.collapsibleMultilevel
  );
  const collapsibleComponent =
    showCollapsible &&
    props.config &&
    selected.key === column.key &&
    showCollapsible ? (
      getCollapsibleIcon(row, column, handelCollapsible, index, selected.isOpen)
    ) : (
      <></>
    );
  if (column.applyColorBadge) {
    return (
      <>
        {collapsibleComponent}
        <>
          <b>{label}</b>
          {applyBadge(
            component,
            value,
            props.isInAddMode ||
              (selectedEditRowId !== undefined &&
                selectedEditRowId.value !== undefined)
          )}
        </>
      </>
    );
  } else {
    if (
      showCollapsible &&
      props.config &&
      selected.key === column.key &&
      showCollapsible
    ) {
      return (
        <div className={"row"}>
          <div className={"collapse-button-container col-xs-2 no-padding"}>
            {collapsibleComponent}
          </div>
          <div className={"col-xs-10"} style={{ paddingTop: "4px" }}>
            <b>{label}</b>
            {component}
          </div>
        </div>
      );
    } else {
      return (
        <>
          {collapsibleComponent}
          <b>{label}</b>
          {component}
        </>
      );
    }
  }
}
export { getFormattedData, getFormattedValues, getFormattedValuesForReport };

/** get formatter values for report */
function getFormattedValuesForReport(value, format, symbol) {
  if (symbol === "%") {
    if (value === "" || value === undefined) {
      return <span className={"number-text"}>{"-"}</span>;
    }
    return (
      <span className={"report-percent-text"}>
        {numberWithCommas(parseFloat(value).toFixed(2))}{"%\r"}
      </span>
    );
  } else {
    if (value === "" || value === undefined) {
      return <span className={"number-text"}>{"-"}</span>;
    }
    return (
      <span className={"report-percent-text"}>
        {"$"}{numberWithCommas(parseFloat(value).toFixed(2))}
      </span>
    );
  }
}

/** set format according to parameter inputs */
function getFormattedValues(
  value,
  format,
  noFormatting = false,
  column = undefined,
  prop = undefined,
  viewTagData = undefined,
  appendText = "",
  isEditableMode = false,
  noDashes = false
) {
  let component = <></>;
  let classes = "";
  let className = "";
  if (column && column.applyColorBadge) {
    classes = " applyColorBadge";
  }

  if (value === false && format === "Text" && noFormatting !== true) {
    return component;
  }

  switch ((format || "").trim()) {
    case "Text":
      if (noFormatting === false) {
        if (value !== null && value !== "" && value !== undefined) {
          component = (
            <div className={"default-text"}>{value + " " + appendText} </div>
          );
        } else {
          component = <div className={"default-text"}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        return value;
      }
      break;
    case "FixedWidthText":
        if (noFormatting === false) {
          if (value !== null && value !== "" && value !== undefined) {
            component = (
              <div className={"fixed-width-text"}>{value + " " + appendText} </div>
            );
          } else {
            component = <div className={"fixed-width-text"}>{noDashes ? "" : "-"}</div>;
          }
        } else {
          return value;
        }
        break;
    case "TextNew":
      className = "right-text";
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value !== null && value !== "" && value !== undefined) {
          component = (
            <div className={className}>{value + " " + appendText} </div>
          );
        } else {
          component = <div className={className}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        return value;
      }
      break;
    case "DateTime":
      className = "date-time-text";
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value !== "0001-01-01T00:00:00"
        ) {
          component = (
            <div className={className}>
              {moment(value).format("MM/DD/YYYY hh:mm A") + " " + appendText}{" "}
            </div>
          );
        } else {
          component = <div className={className}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value !== "0001-01-01T00:00:00"
        ) {
          return moment(value).format("MM/DD/YYYY hh:mm A");
        } else {
          return null;
        }
      }
      break;
    case "Date":
      className = "date-text";
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value !== "0001-01-01T00:00:00"
        ) {
          component = (
            <div className={className}>
              {moment(value).format("MM/DD/YYYY") + " " + appendText}{" "}
            </div>
          );
        } else {
          component = <div className={className}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value !== "0001-01-01T00:00:00"
        ) {
          return moment(value).format("MM/DD/YYYY");
        } else {
          return null;
        }
      }
      break;

    case "Number":
      className =
        "number-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value !== null && isNaN(value) !== true) {
          component = (
            <div className={className}>
              {numberWithCommas(value) + " " + appendText}
            </div>
          );
        } else {
          component = <div className={className}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;

    case "Decimal":
      className =
        "number-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (isNaN(value) !== true) {
          component = (
            <div className={className}>
              {numberWithCommas(parseFloat(value).toFixed(2)) +
                " " +
                appendText}
            </div>
          );
        } else {
          component = <div className={className}>{noDashes ? "" : "-"}</div>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseFloat(parseFloat(value).toFixed(2));
        } else {
          return 0;
        }
      }
      break;

    case "MoneyNumber":
      className =
        "number-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || "").trim() === "") {
          component = <div className={className}>{"$0"}</div>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <div className={className}>
                {"$"}{numberWithCommas(parseInt(value)) + " " + appendText}
              </div>
            );
          } else {
            const newValue = value?.toString();
            const oldValue = newValue?.substr(1);
            component = (
              <div className={className}>
                {"$"}{numberWithCommas(parseInt(oldValue)) + " " + appendText}
              </div>
            );
          }
        } else {
          component = <div className={className}>{"-"}</div>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;

    case "MoneyDecimal":
      className =
        "number-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || "").trim() === "") {
          component = <div className={className}>{"$0"}</div>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <div className={className}>
                {"$"}{numberWithCommas(parseFloat(parseFloat(value)?.toFixed(2)))}
              </div>
            );
          } else {
            const newValue = value?.toString();
            const oldValue = newValue?.substr(1);
            component = (
              <span className={className}>
                {"$(\r"}
                {numberWithCommas(parseFloat(parseFloat(oldValue)?.toFixed(2)))}
                {")\r"}
              </span>
            );
          }
        } else {
          component = <span className={className}>{"-"}</span>;
        }
      } else if (value === "" || isNaN(value) === true) {
        return 0;
      } else {
        if (isNaN(value) !== true) {
          if (value?.toString().substr(value?.length - 1) === ".") {
            return value;
          }
          return parseFloat(
            parseFloat(value)
              ?.toFixed(2)
              .toLocaleString()
          );
        } else {
          return 0;
        }
      }
      break;

    case "Percent":
      className =
        "percent-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || "").trim() === "") {
          component = <div className={className}>{"0%"}</div>;
        } else if (isNaN(value) !== true) {
          component = (
            <div className={className + " " + classes}>
              {numberWithCommas(parseInt(value))}{"% "}{" " + appendText}
            </div>
          );
        } else {
          component = <div className={className + " " + classes}>{"-"}</div>;
        }
      } else {
        if (value !== null && value === "") {
          return 0;
        } else if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
          // return parseFloat(value).toFixed(2);
        } else {
          return 0;
        }
      }
      break;

    case "DecimalPercent":
      className =
        "percent-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || "").trim() === "") {
          component = <div className={className}>{"0%"}</div>;
        } else if (isNaN(value) !== true && value !== null) {
          if (value >= 0) {
            component = (
              <div className={className}>
                {numberWithCommas(parseFloat(value)?.toFixed(2))}{"%\r"}
              </div>
            );
          } else {
            const newValue = value?.toString();
            const oldValue = newValue?.substr(1);
            component = (
              <div className={className}>
                {"("}{numberWithCommas(parseFloat(oldValue)?.toFixed(2))}{")%"}{" "}
                {" " + appendText}
              </div>
            );
          }
        } else {
          component = <span className={className}>{"-"}</span>;
        }
      } else if (value === "" || value.length === 0 || isNaN(value) === true) {
        return 0;
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseFloat(parseFloat(value)?.toFixed(2));
        } else {
          return 0;
        }
      }
      break;
    case "Boolean":
    case "Radio":
      className = "boolean-text";
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        if (value !== undefined) {
          component = <div className={className}>{value ? "Yes" : "No"}</div>;
        } else {
          component = <div className={className}>{"-"}</div>;
        }
      } else {
        if (value !== undefined) {
          return value;
        } else {
          return false;
        }
      }
      break;
    case "MultiText": {
      let arr = [];
      if (typeof value === "string") {
        arr = value.split(",");
        // arr.push(value);
      } else {
        arr = value;
      }
      const tags = removeDuplicates(arr || []);
      // if (tags.length === 0) {
      //   return '-';
      // }
      if (noFormatting === false) {
        component = (
          <>
            {tags.length > 0
              ? tags.map(
                  (chip, i) =>
                    (column === undefined ||
                      column.minTag === undefined ||
                      i < column.minTag) &&
                    chip &&
                    chip !== "" && (
                      <Chip
                        key={chip + i}
                        className={"info chip"}
                        size={"small"}
                        label={chip}
                        title={chip}
                      />
                    )
                )
              : "-"}
            {}
            {column && column.minTag && tags?.length > column.minTag && (
              <div
                style={{ cursor: "pointer" }}
                className={column.viewTagClasses}
                onClick={() =>
                  viewTagData !== undefined &&
                  viewTagData(
                    column.name,
                    tags.map(
                      (chip, i) =>
                        chip &&
                        chip !== "" && (
                          <Chip
                            key={chip + i}
                            className={"info chip"}
                            size={"small"}
                            label={chip}
                          />
                        )
                    )
                  )}
              >
                <br />
                {column.minTagLabel || "... View all"}{" "}
              </div>
            )}
          </>
        );
      } else {
        return value;
      }
      break;
    }
    case "RightAlign":
      className =
        "right-text" + (prop?.config?.sorting === false ? " no-padding" : "");
      if (isEditableMode === true) {
        className = "default-text";
      }
      if (noFormatting === false) {
        component = (
          <span className={className}>{value + " " + appendText}</span>
        );
      } else {
        return value;
      }
      break;
    case "LongText":
      if (noFormatting === false) {
        component = (
          <div className={"long-text"}>
            {(column || {}).prefixChild}
            {value === "" || value === null ? "-" : value}
          </div>
        );
      } else {
        return value;
      }
      break;
    case "EllipsisText":
      if (noFormatting === false) {
        component = (
          <div className={"ellipsis-text"}>
            {(column || {}).prefixChild}
            {value === "" || value === null ? "-" : value}
          </div>
        );
      } else {
        return value;
      }
      break;
    default:
      if (noFormatting === false) {
        component = (
          <div className={"default-text"}>
            {(column || {}).prefixChild}
            {value === "" || value === null ? "-" : value}
          </div>
        );
      } else {
        return value;
      }
  }

  return component;
}

/** set format of value according to given input format */
function getFormattedHeaders(value, format) {
  let component = <></>;
  switch ((format || "").trim()) {
    case "TextNew":
      component = (
        <div className={"right-text table-header"}>
          <p className={"default-text"}>{value}</p>
        </div>
      );
      break;
    case "DateTime":
      component = (
        <div className={"date-text table-header"}>
          <p className={"date-time-text"}>{value}</p>
        </div>
      );
      break;
    case "Date":
      component = (
        <div className={"date-text table-header"}>
          <p className={"date-text"}>{value}</p>
        </div>
      );
      break;
    case "Number":
    case "Decimal":
    case "MoneyNumber":
    case "MoneyDecimal":
      component = (
        <div className={"number-text table-header"}>
          <p className={"number-text"}>{value}</p>
        </div>
      );
      break;
    case "RightAlign":
      component = (
        <div className={"right-text table-header"}>
          <p className={"number-text"}>{value}</p>
        </div>
      );
      break;
    case "Percent":
    case "DecimalPercent":
      component = (
        <div className={"percent-text table-header"}>
          <p className={"percent-text"}>{value}</p>
        </div>
      );

      break;

    case "Boolean":
    case "Radio":
      component = (
        <div className={"boolean-text table-header"}>
          <p className={"boolean-text"}>{value}</p>
        </div>
      );

      break;

    default:
      component = <div className={"default-text table-header"}>{value}</div>;
  }
  return component;
}
export { getFormattedHeaders };
function getCollapsibleIcon(row, col, handelClick, key, isOpen) {
  return (
    <IconButton
      key={col.key + key + row[col.key]}
      aria-label={"expand row"}
      size={"small"}
      style={{ padding: "0px", cursor: "pointer" }}
      onClick={e => {
        e.stopPropagation();
        handelClick(
          col.key,
          row[col.key] + row.marketId?.toString() + row.indexKey?.toString(),
          !isOpen
        );
      }}
    >
      {isOpen ? (
        <Remove className={"collapse-button"} fontSize={"small"} />
      ) : (
        <Add className={"collapse-button"} fontSize={"small"} />
      )}
    </IconButton>
  );
}

/** Format excel data */
export function formatExcelData(format, value) {
  switch ((format || "").trim()) {
    case "Text":
      if (value !== null && value !== "" && value !== undefined) {
        /* empty */
      } else {
        value = "-";
      }
      break;
    case "DateTime":
    case "Date":
      if (
        value !== null &&
        value !== "" &&
        value !== undefined &&
        value !== "0001-01-01T00:00:00"
      ) {
        value = moment(value).format("MM/DD/YYYY");
      } else {
        value = "-";
      }
      break;

    case "Number":
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        isNaN(value) !== true
      ) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case "Decimal":
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        isNaN(value) !== true
      ) {
        value = parseFloat(parseFloat(value).toFixed(2));
      } else {
        value = 0;
      }
      break;

    case "MoneyNumber":
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        isNaN(value) !== true
      ) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case "MoneyDecimal":
      if (value === "" || isNaN(value) === true) {
        value = 0;
      } else {
        if (
          value !== undefined &&
          value !== "" &&
          value !== null &&
          isNaN(value) !== true
        ) {
          if (value.toString().substr(value.length - 1) === ".") {
            return value;
          }
          value = parseFloat(
            parseFloat(value)
              .toFixed(2)
              .toLocaleString()
          );
        } else {
          value = 0;
        }
      }
      break;

    case "Percent":
      if (
        value !== undefined &&
        value !== "" &&
        value !== null &&
        isNaN(value) !== true
      ) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case "DecimalPercent":
      if (value === "" || value.length === 0 || isNaN(value) === true) {
        value = 0;
      } else {
        if (
          value !== undefined &&
          value !== "" &&
          value !== null &&
          isNaN(value) !== true
        ) {
          value = parseFloat(parseFloat(value).toFixed(2));
        } else {
          value = 0;
        }
      }
      break;
    case "Boolean":
    case "Radio":
      if (value !== undefined && value === true) {
        value = "Yes";
      } else {
        value = "No";
      }
      break;
  }

  return value;
}


/** Get formatted values  */
function getFieldValueByFormat(obj) {
  return getFormattedValues(obj.attributeValue, obj.dataFormat, true);
}

export { getFieldValueByFormat };

/** Applying badge */
function applyBadge(component, value, inEditMode) {
  if (value === undefined || isNaN(value)) {
    return component;
  }
  const val = parseInt(value);
  let colorClass = "standardError";
  if (val > 0 && val <= 30) {
    colorClass = "message";
  }
  if (val > 30 && val <= 70) {
    colorClass = "info";
  }
  if (val > 70 && val <= 100) {
    colorClass = "success";
  }
  if (val > 100) {
    colorClass = "standardError";
  }
  if (inEditMode !== true) {
    return (
      <Chip
        className={colorClass + " float-right"}
        size={"small"}
        label={component}
      />
    );
  } else {
    return <Chip className={colorClass} size={"small"} label={component} />;
  }
}
